import { Label, TextInput } from "flowbite-react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ModalFormNumericInputProps {
    register: UseFormRegisterReturn,
    errors: Record<string, any>,
    fieldName: string,
    label: string,
    placeholder: string
}

const ModalFormNumericInput = ({register, errors, fieldName, label, placeholder}: ModalFormNumericInputProps) => {
    return (
        <div>
            <div className="mb-2 block">
                <Label htmlFor={fieldName} value={label} />
            </div>
            <TextInput
                id={fieldName}
                step="any"
                placeholder={placeholder}
                type="number"
                {...register}
            />
            {errors && errors[fieldName] && (
                <div className="text-red-500 text-xs pt-2">{errors[fieldName].message}</div>
            )}
        </div>
    )
}

export default ModalFormNumericInput;